var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinRefineCluster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "34px",
    viewBox: "0 0 31 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pin-Pod") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin-Pod",
    transform: "translate(0.2581, 0.2691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2419355,1 C19.173251,1 22.7318045,2.61534041 25.3079231,5.22514514 C27.8887036,7.8396727 29.483871,11.4519048 29.483871,15.4412435 C29.483871,18.7865284 28.3623368,21.8666553 26.4782435,24.3156591 C24.5561023,26.8141188 21.8407033,28.6563578 18.7143913,29.4504248 C17.9098623,29.6547239 17.1388616,29.9859867 16.4788318,30.487604 L15.9714921,30.8731053 C15.671899,31.1007897 15.4235663,31.388318 15.2420663,31.7167778 C15.0605763,31.3882403 14.8122721,31.1007603 14.5127374,30.8731204 L14.0053819,30.4875212 C13.3452506,29.9860637 12.5743691,29.6548642 11.769835,29.450429 C8.64339596,28.6564554 5.92791798,26.8142683 4.00571845,24.3158063 C2.12157035,21.8668033 1,18.7866275 1,15.4412435 C1,11.4518993 2.59516051,7.83966247 5.17594202,5.22513389 C7.75205467,2.61533524 11.3106043,1 15.2419355,1 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#009AC8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 15.2419355,
    cy: 15.2309048,
    r: 8.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRefineCluster);
export default __webpack_public_path__ + "static/media/Pin-Refine-Cluster.ecae7f3e6e19f7363dfcd172c01b1bba.svg";
export { ForwardRef as ReactComponent };